import React, { useEffect, useState } from 'react';
import * as ajustesApi from '../../api/ajustesEstoque';
import { useExigeEmpresaEspecifica } from '../../hooks/useExigeEmpresaEspecifica';
import AvisoSelecioneEmpresa from '../../components/common/AvisoSelecioneEmpresa';
import PageHeader from '../../components/common/PageHeader';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import StatusBadge from '../../components/common/StatusBadge';
import EmptyState from '../../components/common/EmptyState';
import Skeleton from '../../components/common/Skeleton';
import { usePaginacao } from '../../hooks/usePaginacao';
import { formatDate } from '../../utils/date';

export default function Ajustes() {
  const { bloqueado, carregandoEmpresas, semEmpresaCadastrada } = useExigeEmpresaEspecifica();
  const [itens, setItens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => {
    if (bloqueado) {
      setLoading(false);
      return;
    }
    ajustesApi
      .listAjustes()
      .then((r) => setItens(r.data))
      .catch(() => setErro('Erro ao carregar ajustes.'))
      .finally(() => setLoading(false));
  }, [bloqueado]);

  const { paginados, Paginacao } = usePaginacao(itens);

  if (carregandoEmpresas) return <LoadingSpinner />;

  return (
    <div>
      <PageHeader titulo="Ajustes de Estoque" subtitulo="Perdas, quebras e avarias" acaoLabel="Novo ajuste" acaoTo="/ajustes/novo" />

      {erro && (
        <div className="sf-login-alert mb-3">
          <i className="bi bi-exclamation-circle" />
          {erro}
        </div>
      )}

      {bloqueado && <AvisoSelecioneEmpresa semEmpresaCadastrada={semEmpresaCadastrada} />}

      {!bloqueado && (
        <div className="sf-table-card">
          {loading ? (
            <div className="p-4">
              <Skeleton linhas={5} />
            </div>
          ) : paginados.length === 0 ? (
            <EmptyState icon="bi-exclamation-triangle" titulo="Nenhum ajuste registrado" texto="Perdas, quebras e avarias aparecem aqui." acaoLabel="Novo ajuste" acaoTo="/ajustes/novo" />
          ) : (
            <>
              <div className="table-responsive">
                <table className="sf-table">
                  <thead>
                    <tr>
                      <th>Data</th>
                      <th>Produto</th>
                      <th>Qualidade</th>
                      <th>Lote</th>
                      <th>Quantidade</th>
                      <th>Tipo</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginados.map((a) => (
                      <tr key={a.id_ajuste}>
                        <td>{formatDate(a.data_ajuste)}</td>
                        <td>
                          <span className="d-flex align-items-center gap-2">
                            <span className="sf-cell-icon"><i className="bi bi-exclamation-triangle" /></span>
                            <span className="sf-cell-title">{a.item_lote.lote.produto.nome}</span>
                          </span>
                        </td>
                        <td>{a.item_lote.qualidade.nome}</td>
                        <td>{a.item_lote.lote.codigo}</td>
                        <td>{Number(a.quantidade)} {a.item_lote.unidade_medida.sigla}</td>
                        <td><StatusBadge status={a.tipo} /></td>
                        <td>{a.descricao || '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <Paginacao />
            </>
          )}
        </div>
      )}
    </div>
  );
}
